/**
 * If a promise producing function is called while a previous promise is still pending, returns the same promise instead of calling the function again.
 * While a call is in flight, subsequent calls reuse it and their arguments are ignored.
 * @param fn - a function that returns a promise
 * @returns a function that wraps the original function with deduplication logic
 */
export function dedupeAsync<Args extends unknown[], T>(
  fn: (...args: Args) => Promise<T>
): (...args: Args) => Promise<T> {
  let inFlight: Promise<T> | null = null;
  return async (...args: Args) => {
    if (inFlight) {
      return inFlight;
    }
    inFlight = fn(...args);
    try {
      return await inFlight;
    } finally {
      inFlight = null;
    }
  };
}
